import {fromJS} from 'immutable'
import {ATTEMPT_GET_TOPIC} from './topic'
import {get} from '../../util/http'

/**
 * Actions
 */
const ATTEMPT_GET_TOPIC_FLAT_MAP = 'expii/topicFlatMap/ATTEMPT_GET_TOPIC_FLAT_MAP'
const PROCESS_TOPIC_FLAT_MAP = 'expii/topicFlatMap/PROCESS_TOPIC_FLAT_MAP'

/**
 * Action Creators
 */
function attemptGetTopicFlatMap() {
  return { type: ATTEMPT_GET_TOPIC_FLAT_MAP }
}
function processTopicFlatMap(flatMap) {
  return { type: PROCESS_TOPIC_FLAT_MAP, flatMap }
}

/**
 * Reducer
 */
const defaultState = fromJS({
  flatMap: [],
  currIndex: 0,
  currTopicId: 0,
  isFetching: false,
})

export default function reducer(state = defaultState, action) {
  switch (action.type) {
  case ATTEMPT_GET_TOPIC_FLAT_MAP:
    return state.set('isFetching', true)
  case PROCESS_TOPIC_FLAT_MAP:
    return state.withMutations(m=>(
      m.set('flatMap', fromJS(action.flatMap)).set('isFetching', false).set('currIndex', m.get('flatMap').indexOf(m.get('currTopicId')))
    ))
  case ATTEMPT_GET_TOPIC:
    const topic = parseInt(action.topicId)
    return state.withMutations(m=>(
      m.set('currIndex', m.get('flatMap').indexOf(topic)).set('currTopicId', topic)
    ))
  default:
    return state
  }
}

/**
* Side Effects
*/

export const fetchTopicFlatMap = () => {
  return (dispatch, getState) => {
    dispatch(attemptGetTopicFlatMap())
    return get('/api/v2/flattened_map').then(json => {
      dispatch(processTopicFlatMap(json.output))
    })
  }
}

/**
* Selector
*/

export const selectTopicFlatMap = (state) => {
  return state.get('topicFlatMap')
}

export const selectNthFromCurrentIdInFlatmap = (state, n) => {
  const flatMapState = selectTopicFlatMap(state)
  const currIndex = flatMapState.get('currIndex')
  const flatMap = flatMapState.get('flatMap')
  let nextTopicId = -1
  if (flatMap.size && flatMap.has(currIndex+n)) {
    nextTopicId = flatMap.get(currIndex+n)
  }
  return nextTopicId
}



// WEBPACK FOOTER //
// ./src/redux/modules/topicFlatMap.js